export default "__VITE_ASSET__CIYIB5l2__"